import React from "react";
const FacegateIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g fill="#000" clipPath="url(#clip0_3_2350)">
      <path d="M6.75.75a6 6 0 0 0-6 6v.75a.75.75 0 0 0 1.5 0v-.75a4.5 4.5 0 0 1 4.5-4.5h.75a.75.75 0 0 0 0-1.5zm9.75 0a.75.75 0 1 0 0 1.5h.75a4.5 4.5 0 0 1 4.5 4.5v.75a.75.75 0 1 0 1.5 0v-.75a6 6 0 0 0-6-6zm-15 15a.75.75 0 0 1 .75.75v.75a4.5 4.5 0 0 0 4.5 4.5h.75a.75.75 0 1 1 0 1.5h-.75a6 6 0 0 1-6-6v-.75a.75.75 0 0 1 .75-.75m21.75.75a.75.75 0 1 0-1.5 0v.75c0 .705-.162 1.373-.451 1.967-.162.331-.13.737.13.997.332.33.883.293 1.105-.12a6 6 0 0 0 .716-2.844zm-3.735 6.308c.466-.19.538-.79.18-1.146-.239-.24-.603-.29-.922-.176a4.5 4.5 0 0 1-1.523.264h-.75a.75.75 0 1 0 0 1.5h.75c.801 0 1.566-.157 2.265-.442"></path>
      <path
        fillRule="evenodd"
        d="M9.75 8.625a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m2.25-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-4.5 7.5a3.75 3.75 0 0 1 3.75-3.75h1.5a3.75 3.75 0 0 1 3.75 3.75.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75m7.372-.75a2.25 2.25 0 0 0-2.122-1.5h-1.5a2.25 2.25 0 0 0-2.122 1.5z"
        clipRule="evenodd"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_3_2350">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
    </defs>
  </svg>
);
export default FacegateIcon;
